/** A yes / no question drawn by the kit itself (never the browser's `confirm`). */

import type { KeyInput } from '../../../ui/scene';
import type { KitApi } from '../api';
import { INK } from '../layout';
import { button, dialog } from '../widgets';
import type { Modal } from './modal';

export interface ConfirmOptions {
  readonly title: string;
  readonly lines: readonly string[];
  readonly yes: string;
  readonly no?: string;
  readonly onYes: () => void;
  readonly onNo?: () => void;
  /** The yes button in red: it throws something away. */
  readonly danger?: boolean;
}

export function confirmModal(k: KitApi, o: ConfirmOptions): Modal {
  const answer = (yes: boolean): void => {
    k.closeModal();
    k.sound(yes ? 'select' : 'back');
    if (yes) o.onYes();
    else o.onNo?.();
  };
  const width = Math.max(320, 24 + 8 * Math.max(...o.lines.map((l) => l.length), o.title.length + 4));
  return {
    draw(ui) {
      const h = 50 + o.lines.length * 11;
      const r = dialog(ui, width, h, o.title);
      o.lines.forEach((line, i) => ui.screen.text(line, r.x + 12, r.y + 18 + i * 11, INK.bright));
      const by = r.y + h - 24;
      const bw = 110;
      button(ui, { x: r.x + r.w / 2 - bw - 6, y: by, w: bw, h: 16 }, `${o.yes} (Y)`, {
        id: 'yes', tip: 'Y OR ENTER', ink: o.danger ? INK.error : INK.ok, click: () => answer(true),
      });
      button(ui, { x: r.x + r.w / 2 + 6, y: by, w: bw, h: 16 }, `${o.no ?? 'CANCEL'} (N)`, {
        id: 'no', tip: 'N OR ESC', click: () => answer(false),
      });
    },
    key(key: KeyInput) {
      if (key.code === 'KeyY' || key.code === 'Enter' || key.code === 'NumpadEnter') answer(true);
      else if (key.code === 'KeyN' || key.code === 'Escape' || key.code === 'Backspace') answer(false);
    },
  };
}
